import React from 'react';
import { formatCalendarDate } from '../../utils/bookingDates';
import { GOLD, GOLD_RGBA, CARD_BG, BOOKING_GOLD } from '../../constants/booking';

export default function PriceSummary({
  pricing,
  selectedPackage,
  selectedDate,
  selectedTime,
  durationHours,
  selectedAddOns = [],
  includedAddOns = [],
}) {
  return (
    <div
      style={{
        backgroundColor: CARD_BG,
        borderRadius: '1rem',
        padding: '1.5rem',
        border: `1px solid ${GOLD_RGBA}, 0.25)`,
        marginBottom: '1.5rem',
      }}
    >
      <h3 style={{ fontSize: '1.25rem', fontWeight: '700', marginBottom: '1rem', color: GOLD }}>
        Price Summary
      </h3>

      {selectedPackage && (
        <p style={{ fontSize: '0.8125rem', color: BOOKING_GOLD, marginBottom: '0.75rem', fontWeight: 600 }}>
          {selectedPackage.name} package
        </p>
      )}

      {selectedDate && (
        <div
          style={{
            fontSize: '0.9375rem',
            color: '#F5F0E8',
            marginBottom: '1rem',
            paddingBottom: '1rem',
            borderBottom: '1px solid rgba(201, 168, 76, 0.15)',
          }}
        >
          <div>
            <strong style={{ color: GOLD }}>Date:</strong>{' '}
            {formatCalendarDate(selectedDate, { weekday: 'long', month: 'long', day: 'numeric', year: 'numeric' })}
          </div>
          {selectedTime && (
            <div style={{ marginTop: '0.35rem' }}>
              <strong style={{ color: GOLD }}>Time:</strong> {selectedTime} ({durationHours} hours)
            </div>
          )}
          {(selectedAddOns.length > 0 || includedAddOns.length > 0) && (
            <div style={{ marginTop: '0.35rem' }}>
              <strong style={{ color: GOLD }}>Add-ons:</strong>{' '}
              {[...includedAddOns, ...selectedAddOns].map((a) => a.name).join(', ')}
            </div>
          )}
        </div>
      )}

      <div style={{ display: 'flex', flexDirection: 'column', gap: '0.5rem' }}>
        <div style={{ display: 'flex', justifyContent: 'space-between', fontSize: '0.9375rem' }}>
          <span style={{ color: '#F5F0E8' }}>
            {pricing.isFlatRate
              ? 'Package price (4 hrs included)'
              : `Base price (${pricing.minHours} hrs included)`}
          </span>
          <span style={{ fontWeight: '600', color: '#F5F0E8' }}>${pricing.basePrice}</span>
        </div>

        {!pricing.isFlatRate && pricing.additionalHours > 0 && (
          <div style={{ display: 'flex', justifyContent: 'space-between', fontSize: '0.9375rem' }}>
            <span style={{ color: '#F5F0E8' }}>
              Additional hours ({pricing.additionalHours} × ${pricing.hourlyRate})
            </span>
            <span style={{ fontWeight: '600', color: '#F5F0E8' }}>+${pricing.additionalHoursCost}</span>
          </div>
        )}

        {pricing.addOnsTotal > 0 && (
          <div style={{ display: 'flex', justifyContent: 'space-between', fontSize: '0.9375rem' }}>
            <span style={{ color: '#F5F0E8' }}>Add-ons</span>
            <span style={{ fontWeight: '600', color: '#F5F0E8' }}>+${pricing.addOnsTotal}</span>
          </div>
        )}

        <div
          style={{
            borderTop: '1px solid rgba(201, 168, 76, 0.2)',
            paddingTop: '0.75rem',
            marginTop: '0.5rem',
            display: 'flex',
            justifyContent: 'space-between',
          }}
        >
          <span style={{ fontSize: '1.0625rem', fontWeight: '600', color: '#F5F0E8' }}>Total</span>
          <span style={{ fontSize: '1.0625rem', fontWeight: '700', color: '#F5F0E8' }}>${pricing.total}</span>
        </div>

        <div style={{ display: 'flex', justifyContent: 'space-between', fontSize: '0.875rem' }}>
          <span style={{ color: '#F5F0E8' }}>Due today (25% deposit)</span>
          <span style={{ fontWeight: '700', color: GOLD, fontSize: '1.0625rem' }}>${pricing.deposit}</span>
        </div>
      </div>
    </div>
  );
}
